<template>
  <div>
    <h3>Publish Opportunities</h3>
    <div>
      <b-row>
        <b-col sm="10">
          <b-form inline @submit.prevent="" class="mb-2">
            <b-input-group class="filter-group">
              <b-input-group-prepend is-text class="semester-input-group">
                Semester
              </b-input-group-prepend>
              <b-form-select v-model="semesterId"
                            :options="terms"
                            value-field="termId"
                            text-field="description"/>
            </b-input-group>
            <b-input-group class="filter-group">
              <b-input-group-prepend is-text class="semester-input-group">
                  Type
                </b-input-group-prepend>
              <b-form-select id="types" v-model="opportunityTypeId" :options="opportunityTypes" value-field="opportunityTypeId" text-field="name">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">All</option>
                </template>
              </b-form-select>
            </b-input-group>
            <b-input-group class="filter-group ml-2" >
              <b-input-group-prepend is-text>
                  <font-awesome-icon icon="search" />
              </b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                  <b-button @click="filter = null">Clear</b-button>
              </b-input-group-append>
            </b-input-group>    
          </b-form>
        </b-col>
        <b-col sm="2">
          <b-button class="new-opportunity-button float-right" :to="{name: 'opportunityAdd'}">
            <font-awesome-icon icon="plus" /> New Opportunity
          </b-button>
        </b-col>
      </b-row>

      <b-card no-body>
        <b-tabs card>
          <b-tab active>
            <template slot="title">
              <tab-item icon="plus" heading="Not Published" subheading=""></tab-item>
            </template>
            <div class="form-panel">
              <a :href="notPublishedCsvUrl">Download CSV</a>
              <table-display :opportunities="filteredNotPublished"
                             
                             selectable
                             publish
                             @saveChanges="publishOpportunities"></table-display>
            </div>
          </b-tab>
          <b-tab>
            <template slot="title">
              <tab-item icon="check-circle" heading="Published" subheading=""></tab-item>
            </template>
            <div class="form-panel">
              <a :href="publishedCsvUrl">Download CSV</a>
              <table-display :opportunities="filteredPublished" :filter="filter"></table-display>
            </div>
          </b-tab>
          <b-tab>
            <template slot="title">
              <tab-item icon="times-circle" heading="Not Ready" subheading=""></tab-item>
            </template>
            <div class="form-panel">
              <a :href="notReadyCsvUrl">Download CSV</a>
              <table-display :opportunities="filteredNotReady" :filter="filter"></table-display>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import TabItem from "@/components/menu/tab-item";
import TableDisplay from "@/components/opportunities/table-display";
import opportunitiesApi from "../../api/opportunity";
import termsApi from "../../api/terms";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";

export default {
  data() {
    return {
      terms: [],
      filter: null,
      semesterId: null,
      notPublished: [],
      published: [],
      notReady: [],
      opportunityTypes: [],
      opportunityTypeId: null
    };
  },

  components: {
    "tab-item": TabItem,
    "table-display": TableDisplay
  },

  computed: {
    publishedCsvUrl() {
      return process.env.VUE_APP_BASE_URI + "/api/opportunityReports/publishedcsv?termid=" + this.semesterId;
    },
    notPublishedCsvUrl() {
      return process.env.VUE_APP_BASE_URI + "/api/opportunityReports/notpublishedcsv?termid=" + this.semesterId;
    },
    notReadyCsvUrl() {
      return process.env.VUE_APP_BASE_URI + "/api/opportunityReports/notreadycsv?termid=" + this.semesterId;
    },
    filteredPublished: function() {
      var that = this;
      return _.filter(this.published, item => {
        return that.filterItems(item, this.opportunityTypeId, this.filter);
      });
    },
    filteredNotPublished: function() {
      var that = this;
      var filter = this.filter;
      return _.filter(this.notPublished, item => {
        return that.filterItems(item, this.opportunityTypeId, filter);
      });
    },
    filteredNotReady: function() {
      var that = this;
      return _.filter(this.notReady, item => {
        return that.filterItems(item, this.opportunityTypeId, this.filter);
      });
    }
  },

  methods: {
    filterItems(item, type, search) {
      var matchedType = this.matchType(item, type);
      var matchedFilter = this.matchFilter(item, search);

      if (matchedType && matchedFilter) {
        return true;
      }
      return false;
    },
    matchType(item, opportunityTypeId) {
      if (
        opportunityTypeId === null ||
        item.opportunityType.opportunityTypeId === opportunityTypeId
      ) {
        return true;
      }
      return false;
    },
    matchFilter(item, filter) {
      if (filter != "" && filter != null) {
        var found = this.search([item], this.filter);
        return found.length > 0;
      }
      return true;
    },
    search(collection, text) {
      var that = this;
      return _.filter(collection, function(object) {
        var search = that.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },
    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function(val, key) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function(memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    },
    getOpportunities: function() {
      var that = this;
      opportunitiesApi
        .getNotPublishedOpportunitiesByTerm(this.semesterId)
        .then(function(response) {
          that.notPublished = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
      opportunitiesApi
        .getPublishedOpportunitiesByTerm(this.semesterId)
        .then(function(response) {
          that.published = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
      opportunitiesApi
        .getNotReadyOpportunitiesByTerm(this.semesterId)
        .then(function(response) {
          that.notReady = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    publishOpportunities: function(selectedOpportunities) {
      var that = this;

      opportunitiesApi
        .postPublishOpportunities(selectedOpportunities)
        .then(function() {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("The opportunities have been published.", "Success");

          that.getOpportunities();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },

  watch: {
    semesterId: function() {
      this.getOpportunities();
    }
  },

  created() {
    var that = this;
    opportunitiesApi.getOpportunityTypes().then(response => {
      that.opportunityTypes = response.data;
    });
    termsApi
      .getCurrentAndFutureTerms()
      .then(function(response) {
        that.terms = response.data;
        that.semesterId = that.terms[0].termId;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
/* .filter-group {
  max-width: 700px;
}

.filter-group,
.new-opportunity-button {
  margin: 10px 0 15px 0;
} */

label {
  font-weight: bold;
  margin: 0 0.3em 0 1.5em;
}
.semester-input-group {
  margin-left: 10px;
}
</style>
